module.exports = __webpack_public_path__ + "assets/img/btn-download-xbox-121e776a.png";